import { useQuery } from '@tanstack/react-query';

import { configurationApi } from 'service/api/configurationApi';

import type { Policies } from 'service/api/configurationApi';
import type { UseQueryOptions } from '@tanstack/react-query';

type UseGetPoliciesOptions = Omit<
  UseQueryOptions<Policies, unknown, Policies, ['getPolicies']>,
  'queryKey' | 'queryFn'
>;

export const useGetPolicies = (options?: UseGetPoliciesOptions) =>
  useQuery<Policies, unknown, Policies, ['getPolicies']>({
    queryKey: ['getPolicies'],
    queryFn: () => configurationApi().getPolicies(),
    staleTime: Infinity,
    ...options,
  });
